export default "__VITE_ASSET__d640087d__"